"use client";
import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { ContentText } from '../ContentText/ContentText.web.js';
import { Link } from '../Link/Link.web.js';
import { IconUpload } from '../icons/ui_file/IconUpload.web.js';
import { IconError } from '../icons/ui_general/IconError.web.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { spacing } from '../constants/spacing.js';
import { IconCheck } from '../icons/ui_control/IconCheck.web.js';

var DefaultMessage = function DefaultMessage() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, "Drop file here or click to", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "#",
    onClick: function onClick(event) {
      event.preventDefault();
    }
  }, "select file"));
};
var FilesUploading = function FilesUploading(props) {
  var _props$message = props.message,
    message = _props$message === undefined ? 'Uploading...' : _props$message,
    theme = props.theme;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconUpload, {
    mr: spacing.xxxxs,
    color: theme.fileUpload.web.inactiveText
  }), /*#__PURE__*/React.createElement(ContentText, {
    textAlign: "center",
    display: "inline",
    color: theme.fileUpload.web.inactiveText
  }, message));
};
var FilesAccepted = function FilesAccepted(props) {
  var _props$message2 = props.message,
    message = _props$message2 === undefined ? 'Drop file here' : _props$message2,
    theme = props.theme;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconCheck, {
    mr: spacing.xxxxs,
    color: theme.colors.primary
  }), /*#__PURE__*/React.createElement(ContentText, {
    textAlign: "center",
    display: "inline"
  }, message));
};
var FilesRejected = function FilesRejected(props) {
  var _props$message3 = props.message,
    message = _props$message3 === undefined ? 'Not a valid file selection' : _props$message3,
    theme = props.theme;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconError, {
    mr: spacing.xxxxs,
    color: theme.colors.alert
  }), /*#__PURE__*/React.createElement(ContentText, {
    color: theme.colors.alert,
    textAlign: "center",
    display: "inline"
  }, message));
};
var FilesDragging = function FilesDragging(props) {
  var _props$message4 = props.message,
    message = _props$message4 === undefined ? 'Move file here' : _props$message4,
    theme = props.theme;
  // FIXME: the color doesn't come from the theme
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconUpload, {
    mr: spacing.xxxxs,
    color: theme.fileUpload.web.inactiveText
  }), /*#__PURE__*/React.createElement(ContentText, {
    textAlign: "center",
    display: "inline",
    color: theme.fileUpload.web.inactiveText
  }, message));
};
var FileUploadDisabled = function FileUploadDisabled(props) {
  var _props$message5 = props.message,
    message = _props$message5 === undefined ? 'Drop file here or click to select file' : _props$message5,
    theme = props.theme;
  // FIXME: the color doesn't come from the theme
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconUpload, {
    mr: spacing.xxxxs,
    color: theme.fileUpload.web.inactiveText
  }), /*#__PURE__*/React.createElement(ContentText, {
    textAlign: "center",
    display: "inline",
    color: theme.fileUpload.web.inactiveText
  }, message));
};
var FileUploadDefaultContent = function FileUploadDefaultContent(props) {
  var isDragAccept = props.isDragAccept,
    isDragActive = props.isDragActive,
    isDragReject = props.isDragReject,
    isDisabled = props.isDisabled,
    isUploading = props.isUploading,
    messages = props.messages;
  var theme = useTheme();
  if (isUploading) {
    return /*#__PURE__*/React.createElement(FilesUploading, {
      theme: theme,
      message: messages === null || messages === undefined ? undefined : messages.uploading
    });
  }
  if (isDragAccept) {
    return /*#__PURE__*/React.createElement(FilesAccepted, {
      theme: theme,
      message: messages === null || messages === undefined ? undefined : messages.dragAccept
    });
  }
  if (isDragReject) {
    return /*#__PURE__*/React.createElement(FilesRejected, {
      theme: theme,
      message: messages === null || messages === undefined ? undefined : messages.dragReject
    });
  }
  if (isDragActive) {
    return /*#__PURE__*/React.createElement(FilesDragging, {
      theme: theme,
      message: messages === null || messages === undefined ? undefined : messages.dragActive
    });
  }
  if (isDisabled) {
    return /*#__PURE__*/React.createElement(FileUploadDisabled, {
      theme: theme,
      message: messages === null || messages === undefined ? undefined : messages.disabled
    });
  }
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconUpload, {
    mr: spacing.xxxxs
  }), /*#__PURE__*/React.createElement(ContentText, {
    display: "inline",
    textAlign: "center"
  }, (messages === null || messages === undefined ? undefined : messages["default"]) || /*#__PURE__*/React.createElement(DefaultMessage, null))));
};

export { FileUploadDefaultContent };
